<template>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="用户充值" name="first">
            <el-card shadow="never" class="l-main-card">
                <l-table :data="data" row-key="id" v-loading="loading" style="height: 700px;">
                    <el-table-column fixed prop="index" label="序号" width="80"> </el-table-column>
                    <el-table-column prop="app_id" label="归属平台" min-width="140" show-overflow-tooltip>
                        <template slot-scope="{ row }">
                            {{ APP_TYPE[row.app_id] }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="app_user_id" label="用户ID" min-width="200" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="app_user_name" label="用户名称" min-width="200" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="corp_name" label="归属公司" min-width="200" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="depart_name" label="归属部门" min-width="200" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="group_name" label="小组" min-width="220" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="admin_name" label="员工名" min-width="200" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="ProviderName" label="渠道名称" min-width="200"
                        show-overflow-tooltip></el-table-column>
                    <el-table-column prop="PaymentType" label="支付类型" min-width="200" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="money" label="充值金额（¥）" min-width="200" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="gold" label="充值金币" min-width="100" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="PaidTime" label="支付时间" min-width="200" show-overflow-tooltip> </el-table-column>
                </l-table>

                <!--分页-->
                <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size"
                    :current-page.sync="page"></l-page>
            </el-card>
        </el-tab-pane>
        <el-tab-pane label="用户流水" name="second">
            <el-card shadow="never" class="l-main-card">
                <l-table :data="data" v-loading="loading" row-key="id" style="height: 700px;">
                    <el-table-column fixed prop="index" label="序号" width="80"> </el-table-column>
                    <el-table-column prop="app_id" label="归属平台" min-width="140" show-overflow-tooltip>
                        <template slot-scope="{ row }">
                            {{ APP_TYPE[row.app_id] }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="Reason" label="备注" min-width="200" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="sociaty" label="公会" min-width="120" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="room_name" label="厅/房间" min-width="120" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="room_id" label="房间id" min-width="120" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="admin_name" label="员工名" min-width="130" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="app_user_id" label="用户ID" min-width="220" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="app_user_name" label="用户昵称" min-width="150" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="total_price" label="价值金币" min-width="150" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="gift_app_user_id" label="送礼对象ID" min-width="220" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="gift_app_user_name" label="送礼对象昵称" min-width="150" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="add_time_new" label="时间" min-width="200" show-overflow-tooltip>
                    </el-table-column>
                </l-table>

                <!--分页-->
                <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size"
                    :current-page.sync="page"></l-page>

            </el-card>
        </el-tab-pane>
        <el-tab-pane label="公会转账" name="third">
            <el-card shadow="never" class="l-main-card">
                <l-table :data="data" v-loading="loading" row-key="id" style="height: 700px;">
                    <el-table-column fixed prop="index" label="序号" width="80"> </el-table-column>
                    <el-table-column prop="app_id" label="归属平台" min-width="140" show-overflow-tooltip>
                        <template slot-scope="{ row }">
                            {{ APP_TYPE[row.app_id] }}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="Reason" label="备注" min-width="200" show-overflow-tooltip> </el-table-column> -->
                    <el-table-column prop="sociaty" label="代充公会" min-width="160" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="give_gift_user_id" label="代充人ID" min-width="200" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="give_gift_user_name" label="代充人昵称" min-width="160" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="corp_name" label="员工公司" min-width="160" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="depart_name" label="员工部门" min-width="160" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="group_name" label="员工小组" min-width="160" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="admin_name" label="员工名" min-width="160" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="coin" label="代充金币" min-width="160" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="app_user_id" label="收款用户ID" min-width="200" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="app_user_name" label="收款用户昵称" min-width="160" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="add_time_new" label="时间" min-width="200" show-overflow-tooltip>
                    </el-table-column>
                </l-table>

                <!--分页-->
                <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size"
                    :current-page.sync="page"></l-page>
            </el-card>

        </el-tab-pane>
        <el-tab-pane label="后台充值" name="fourth">
            <el-card shadow="never" class="l-main-card">
                <l-table :data="data" v-loading="loading" row-key="id" style="height: 700px;">
                    <el-table-column fixed prop="index" label="序号" width="80"> </el-table-column>
                    <el-table-column prop="app_id" label="归属平台" min-width="140" show-overflow-tooltip>
                        <template slot-scope="{ row }">
                            {{ APP_TYPE[row.app_id] }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="corp_name" label="员工公司" min-width="160" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="depart_name" label="员工部门" min-width="160" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="group_name" label="员工小组" min-width="160" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="admin_name" label="员工名" min-width="160" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="coin" label="代充金币" min-width="160" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="app_user_id" label="代充用户ID" min-width="200" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="app_user_name" label="代充用户昵称" min-width="160" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="add_time_new" label="时间" min-width="200" show-overflow-tooltip>
                    </el-table-column>
                </l-table>

                <!--分页-->
                <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size"
                    :current-page.sync="page"></l-page>
            </el-card>
        </el-tab-pane>
    </el-tabs>
</template>
<script>
import Vue from "vue";
import { APP_TYPE, PAY_TYPE } from "../appUser/state";
export default {
    name: "l-appuser-info",
    components: {
    },
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
        visible: {
            type: Boolean,
        },
    },
    data() {
        return {
            data: [],
            count: 0,
            page: 1,
            loading: true,
            page_size: Vue.$_config.page.page_size,
            info_id: 0,
            activeName: 'first',
            search_data: {
                info_app_user_id: ""
            },
            APP_TYPE: APP_TYPE,
            PAY_TYPE: PAY_TYPE,
            f: "appUserRecharge_getList",

        };
    },
    watch: {
        visible: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.search_data.info_app_user_id = this.$props.id;
                    this.getList();
                }
            },
        },
    },
    methods: {
        getList() {
            this.loading = true;
            this.$_invoke(this.f, {
                page: this.page,
                page_size: this.page_size,
                ...this.search_data,
            })
                .then((ret) => {
                    console.log(ret.data);
                    this.data = ret.data;
                    this.count = ret.count;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        handleClick() {
            if (this.activeName == 'first') {
                this.f = "appUserRecharge_getList";
                this.getList();
            } else if (this.activeName == 'second') {
                this.f = "appUserConsume_getList";
                this.getList();
            } else if (this.activeName == 'third') {
                this.f = "appUserSociaty_getList";
                this.getList();
            } else {
                this.f = "appUserAdmin_getList";
                this.getList();
            }
        }
    }
};
</script>